<template>
  <div class="mb-10">
    <v-card class="mt-2 mb-4 pa-4" color="#ebebeb" flat :loading="loading">
      <div class="d-flex flex-row flex-wrap justify-space-between align-center">
        <div>
          <div class="text-h5">{{ pageTitle }}</div>
          <div class="caption py-1" v-if="data && data.slug">
            /{{ data.slug }}

            <span v-if="data && data.slug && data.slug != ''"
              ><v-btn icon x-small @click="editSlugPrompt()"
                ><v-icon x-small color="primary">mdi-pencil</v-icon></v-btn
              ></span
            >
          </div>
        </div>
        <div>
          <!-- <v-btn depressed @click="doDelete()" color="red" text v-if="!newItem">
              Delete</v-btn
            > -->
          <v-btn depressed @click="exitPage()" class="mx-2" text> Cancel</v-btn
          ><v-btn
            :disabled="!valid"
            depressed
            color="primary"
            class="mx-2"
            @click="doSave()"
            text
          >
            Save</v-btn
          >
        </div>
      </div>

      <div class="caption d-flex flex-row flex-wrap align-center" v-if="data">
        <div class="mx-3" v-if="!newItem">id: {{ data.id }}</div>
        <div class="mx-3" v-if="data.added">Added: {{ data.added }}</div>
        <div class="mx-3" v-if="data.updated">Updated: {{ data.updated }}</div>
        <v-checkbox
          class="mx-3 my-0 py-0"
          v-model="data.display"
          dense
          :hide-details="true"
          label="Publish"
        ></v-checkbox>
      </div>
    </v-card>
    <v-alert type="warning" v-if="error">{{ error }}</v-alert>

    <v-form v-model="valid" v-if="data" class="mb-2" lazy-validation>
      <div class="mb-3">
        <div style="max-width: 800px">
          <v-text-field
            label="Table Name"
            v-model="data.title"
            outlined
            class="mr-4"
            @change="nameChange()"
            :rules="nameRules"
            required
          ></v-text-field>

          <v-textarea
            label="Aliases"
            v-model="data.aliases"
            outlined
            class="mr-4"
            messages="Words or phrases that might make this easier to search for"
          ></v-textarea>
        </div>
      </div>

      <table-maker
        :title="data.title"
        :tableData="tableData"
        :deactivatePreviewLinks="true"
        @table="tableData = $event"
      ></table-maker>

      <image-browser-uploader
        :previousFiles="data.image ? [data.image] : []"
        :fileNameRoot="'protocol_' + slug"
        :limit="1"
        path="/images/pathologies/"
        @fileList="newImageFiles = $event"
        class="my-1"
        title="Image"
      ></image-browser-uploader>

      <!-- end content fields -->
    </v-form>

    <!-- <v-card class="my-8">{{ data }}</v-card> -->
    <v-alert v-if="error">{{ error }}</v-alert>
    <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      {{ pageTitle }} Updated</v-snackbar
    >
    <v-snackbar v-model="deletedSnackbar" :timeout="2000" top color="alert">
      {{ pageTitle }} Deleted</v-snackbar
    >

    <!-- {{ data }} -->
    <!-- <md-textarea v-model="testValue"></md-textarea> -->
    <!-- <v-combobox v-model="testModel" :items="testItems" no-filter> </v-combobox> -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import Slugify from "slugify";
import TableMaker from "@/components/adminStuff/TableMaker";
// import MdTextarea from "@/components/adminStuff/MdTextarea";
import GetJsonMixin from "@/assets/js/GetJsonMixin";
import ImageBrowserUploader from "../ImageBrowserUploader.vue";

export default {
  name: "EditProtocol",
  components: {
    // MdTextarea,
    TableMaker,
    ImageBrowserUploader,
  },
  mixins: [UserMixin, GetJsonMixin],
  props: {
    slug: null,
  },
  data: function () {
    return {
      loading: false,
      error: null,
      pageTitle: "Add Billing Protocol",
      apiPath: "/billing-protocols/addUpdate",
      updatedSnackbar: false,
      deletedSnackbar: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length >= 6 || "Name must be at least 6 characters",
      ],
      newImageFiles: [],
      defaultData: {
        id: 0,
        title: "",
        slug: "",
        aliases: "",
        headers: null,
        groups: null,
        notes: null,
        image: null,
        display: 1,
        added: null,
        updated: null,
      },
      data: null,
      valid: false,
      tableData: null, // will be set from api data in populateContentFromAPI(), then updated from table-maker
      slugManuallyUpdated: false,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      if (!this.slug) return; // show error?
      this.error = null;
      let api = "/billing-protocols/all?admin=1&item=" + this.slug;
      ApiServices.genericApiCall(api) // admin = true
        .then((response) => {
          // this.data = response.data;
          this.populateContentFromAPI(response.data.protocols[0]);
          this.pageTitle = this.data.title;
          // this.apiPath = this.data.update_route;
          this.error = null;

          // this.emitPath();
        })
        .catch((error) => {
          console.log("error", error);
          //   this.data = null;
          if (error) this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exitPage() {
      this.$router.push({ path: "/boss/billing-protocols" });
    },
    doSave() {
      this.loading = true;
      let data = { ...this.data };
      this.error = null;
      data.auth = this.auth_credentials;
      data.headers = this.tableData.headers;
      data.groups = this.tableData.groups;
      data.notes = this.tableData.notes;

      let imgs = this.newImageFiles;
      data.image = imgs && imgs.length > 0 ? imgs[0] : null;

      ApiServices.genericUpdateItem(this.apiPath, data)
        .then((response) => {
          if (response.data.error) {
            this.error = response.data.error;
          } else if (response.data.success) {
            this.error = null;
            // this.$emit("edited", true);
            this.updatedSnackbar = true;
            this.exitPage();
            // this.$router.push({ path: "/admin/ocular-conditions" });
          }
          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        })
        .finally(() => {});
    },
    resetAll: function () {
      this.data = { ...this.defaultData };
      this.pageTitle = "Add Billing Protocol";
    },
    populateContentFromAPI(data) {
      if (data?.display) data.display = parseInt(data.display);
      if (data.headers && data.groups) {
        let notes = data.notes ? data.notes : "";
        this.tableData = {
          headers: data.headers,
          groups: data.groups,
          notes: notes,
        };
      }

      this.data = data;
    },

    nameChange() {
      if (this.data.name != "") this.pageTitle = this.data.name;
      if (!this.slugManuallyUpdated && this.newItem)
        this.updateSlug(this.data.name);
    },
    updateSlug(val) {
      if (val && this.data) {
        val = val.replace(/[()]/g, " ");
        this.data.slug = Slugify(val.toLowerCase());
      }
    },

    editSlugPrompt() {
      if (!this.data?.slug) return;
      let txt = "Choose a new vanity URL for item.";
      if (!this.newItem)
        txt +=
          "\n\nPlease be aware that changing the vanity URL will break any existing links to this item's listing! ";
      let newSlug = prompt(txt, this.data.slug);
      if (newSlug && newSlug != this.data.slug) {
        this.updateSlug(newSlug);
        this.slugManuallyUpdated = true;
      }
    },
    doDelete() {
      var confirmVar = confirm(
        "Are you sure you want to delete " +
          this.data.name +
          "? This cannot be undone"
      );
      if (confirmVar) {
        this.loading = true;
        let auth = this.auth_credentials;
        let data = { id: this.data.id, delete: true, auth: auth };
        // todo - consolidate this stuff with the doSave() method
        ApiServices.genericUpdateItem(this.apiPath, data)
          .then((response) => {
            if (response.data.error) {
              this.error = response.data.error;
            } else if (response.data.success) {
              this.error = null;
              // this.$emit("edited", true);
              this.deletedSnackbar = true;
              this.exitPage();
            }
          })
          .catch((error) => {
            console.log(error);
            this.error = error;
          })
          .finally(() => {});
      }
    },
  },
  computed: {
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp ? "bigHead" : "smallHead";
    },

    newItem: function () {
      return this.slug == "new";
    },
  },
  watch: {},

  mounted() {
    if (!this.newItem) {
      this.getData();
    } else {
      // console.log("new item");
      this.resetAll(); // uses default data
    }
  },
  metaInfo() {
    return {
      title: "EyeDock Admin - Conditions " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.bigHead {
  min-width: 170px;
  max-width: 170px;
}
.bigHead {
  width: 100%;
}
.headerBkg {
  background-color: #e0f2ff;
  /* border-bottom: 1px solid #bfd5e5; */
  /* margin-bottom: -1px; */
}
.rowColor {
  background-color: #eaf6ff;
}
.sectionDiv {
  border: 1px solid #bfd5e5;
  margin-bottom: -1px;
}
</style>
